import CertificateNavTab from '../../../components/certificates/CertificateNavTab';
import CertificateNav from '../../../components/certificates/CertificateNav';
import { Navigate, Route, Routes } from 'react-router-dom';
import CommissionsTab from './CommissionsTab';
import DashboardTab from './DashboardTab';
import React from 'react';
import JobsTab from './JobsTab';


const ExpertPage = ({activeTab}) => {
    

    return (
        <>
            <CertificateNav activeTab={activeTab}>
                <CertificateNavTab eventKey='dashboard' to='/certificates/expert/dashboard' text='Dashboard' />
                <CertificateNavTab eventKey='commissions' to='/certificates/expert/commissions' text='Commissions' />
                <CertificateNavTab eventKey='jobs' to='/certificates/expert/jobs' text='Jobs' />
            </CertificateNav>

            <Routes>
                <Route path="/" element={<Navigate to="./dashboard" />} />
                <Route path="dashboard" element={<DashboardTab />} />
                <Route path="commissions/:id?" element={<CommissionsTab />} />
                <Route path="jobs/:id?" element={<JobsTab />} />
            </Routes>
        </>
    );
};

export default ExpertPage;